import React from "react";
import img1 from "../assets/images/sidom/fotos/Nosotros/valores/user-astronaut-solid.svg";
import img2 from "../assets/images/sidom/fotos/Nosotros/valores/door-open-solid.svg";
import img4 from "../assets/images/sidom/fotos/Nosotros/valores/lightbulb-solid.svg";
import img6 from "../assets/images/sidom/fotos/Nosotros/valores/rainbow-solid.svg";
import img7 from "../assets/images/sidom/fotos/Nosotros/valores/trophy-solid.svg";
import img8 from "../assets/images/sidom/fotos/Nosotros/valores/rocket-solid.svg";
export default function VisionMissionValues() {
  return (
    <div>
      <div className="w-full">
        <div className="flex flex-col justify-center items-center w-full gap-10 px-2 md:px-0 lg:px-0 mb-[70px] md:mb-[100px] lg:mb-[90px] mt-[70px] md:mt-[100px] lg:mt-[90px]">
          <div className="flex flex-col mt-[30px] md:mt-[60px]  gap-9 lg:gap-10  container md:flex-row w-full justify-start items-start ">
            <div className=" w-full md:w-[50%] justify-center items-center">
              <h1 className=" font-extrabold text-left md:text-right text-3xl text-sidom-orange pr-3 mb-2">
                Nuestra visión
              </h1>
            </div>
            <div className="w-full md:w-[50%]  text-left flex ">
              <p className=" text-base  text-sidom-dark dark:text-sidom-light">
                Ser la solución tecnológica global, simplificando el comercio
                internacional con innovación y talento, agregando valor a las
                mejores compañías del mundo, nuestros clientes.
              </p>
            </div>
          </div>

          <div className="flex  flex-col mt-[30px] md:mt-[60px] gap-9 lg:gap-10  container md:flex-row w-full justify-center items-center   ">
            <div className="w-full md:w-[50%] justify-center items-center ">
              <h1 className="font-extrabold text-left md:text-right text-3xl text-sidom-orange  pr-3 mb-2">
                Nuestra misión
              </h1>
            </div>
            <div className="w-full md:w-[50%]  md:text-left flex">
              <p className=" text-base  text-center  text-sidom-dark dark:text-sidom-light">
                Hacemos simple lo complejo.
              </p>
            </div>
          </div>

          <div className="flex  flex-col mt-[60px] gap-9 lg:gap-10 container md:flex-row w-full justify-center items-start   ">
            <div className="w-full md:w-[50%] justify-start items-start ">
              <h1 className="font-extrabold text-left md:text-right text-3xl text-sidom-orange  pr-3  mb-2">
                Nuestros valores
              </h1>
            </div>

            <div className="w-full md:w-[50%]   text-left flex ">
              <ul className="flex flex-col justify-start items-start text-sm lg:text-base  text-sidom-dark dark:text-sidom-light">
                <li className="flex justify-center gap-1 mb-4  items-center ">
                  <img src={img8} className=" w-6" alt="img" />
                  #ToTheMoon
                </li>
                <li className="flex justify-center gap-1 mb-4 items-center">
                  <img src={img2} className=" w-6" alt="img" />
                  #somosTRANSPARENTES
                </li>
                <li className="flex justify-center gap-1 mb-4 items-center">
                  <img src={img4} className=" w-6" alt="img" />
                  #somosINNOVACIÓN
                </li>
                <li className="flex justify-center gap-1 mb-4 items-center">
                  <img src={img7} className=" w-6" alt="img" />
                  #somosEXCELENCIA
                </li>
                <li className="flex justify-center gap-1 mb-4 items-center">
                  <img src={img1} className=" w-6" alt="img" />
                  #somosCUSTOMEROBSESSED
                </li>
                <li className="flex justify-center gap-1 mb-4 items-center">
                  <img src={img6} className="w-6" alt="img" />
                  #somosDIVERSIDAD
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
